/*
 * @Author: xuejian3721
 * @Date: 2025-03-13 12:08:56
 * @LastEditors: xuejian3721
 * @LastEditTime: 2025-04-03 09:40:25
 */
// 设置商品卡片样式
export function setCommodityCardStyle(commodityObj) {
  return commodityCardMobileStyle(commodityObj)
}

// app端样式
function commodityCardMobileStyle(commodityObj) {
  return `<div class="msg-card-commodity"
    style="min-width: 267px;display: flex;align-items: center;justify-content: space-between;background: #fff;border-radius: 5px;padding:10px;margin: 4px 0;">
    <img style="width: 55px;height: 55px;margin-right: 10px;background-size: cover;flex: 0 0 55px;" src="${commodityObj.mainPicUrl ||
      'https://s.yyjzt.com/kf-web/20240617/1718610240350455b.jpg'}"/>
    <div style="display: flex;flex-direction: column;flex: 1;overflow: hidden;margin: 0 0 0 10px;min-height: 60px;">
      <div style="padding: 3px 0;">
        <span style="font-size: 15px;color: #111111;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;word-break: break-word;line-height: 20px;font-family: PingFang SC, Microsoft YaHei, Arial, sans-serif;">
          ${commodityObj.itemStoreName} ${commodityObj.specs}
        </span>
      </div>
      <div style="margin: 3px 0;">
        <span style="font-size: 14px;color: #FF0000;">
          <span style="font-size: 10px;transform: scale(0.5);transform-origin: 0 0;">￥</span>
          ${commodityObj.salePriceShow || '-'}
        </span>
      </div>
    </div>
  </div>`
}
